import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import {Button} from '../../../components/Button';

const SelectTypeModal = (props) => {

  const {
    onClosePaymentTypeModal,
    isShowSelectTypeModal,
    onSelectedType
  } = props;
  return (
    <Modal
      onRequestClose={onClosePaymentTypeModal}
      isOpen={isShowSelectTypeModal}
      shouldCloseOnOverlayClick={false}
      showCloseIcon
    >
      <h3>Pleas select payment type</h3>
      <Button
        name="PayPal"
        onClick={()=>onSelectedType('paypal')}
      />
      <Button
        name="Card"
        onClick={()=>onSelectedType('cart')}
      />
    </Modal>
  )
};

SelectTypeModal.propTypes = {
  onClosePaymentTypeModal: PropTypes.func,
  isShowSelectTypeModal: PropTypes.bool,
  onSelectedType: PropTypes.func,
};

export default SelectTypeModal;


// WEBPACK FOOTER //
// ./src/app/containers/Booking/components/SelectPaymentType.js